import type { ShiftRecordMap } from '@libs/data-access/queries'
import { DEFAULT_CONTRACT_TIME } from '@spa/constants'
import { formatToWeekISO } from '@spa/services/utils'
import type Immutable from 'immutable'
import type { Moment } from 'moment'
import moment from 'moment'
import { getShiftRealDuration } from 'snap-redux/modules/shifts'

import type { TableRevaluatedData } from './revaluation.types'

const getCompleteWeek = (week: Moment, startDate: Moment, endDate: Moment) => {
  const firstDayOfWeek = week.clone().startOf('isoWeek')
  const lastDayOfWeek = week.clone().endOf('isoWeek')

  const isWeekInPeriod =
    firstDayOfWeek.isSameOrAfter(startDate.startOf('day')) &&
    lastDayOfWeek.isSameOrBefore(endDate.endOf('day'))

  return isWeekInPeriod
}

export const getRevaluatedData = (
  weeksInRange: Immutable.List<Moment>,
  contractTimeByWeek: { [key: string]: any },
  accountPaidBreaks: boolean,
  startDate: Moment,
  endDate: Moment,
  shiftsInRange: ShiftRecordMap
): TableRevaluatedData[] => {
  return weeksInRange.toArray().map(week => {
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    const shiftsOfTheWeek = shiftsInRange.filter(({ starts_at: startsAt }) =>
      moment(startsAt).isSame(week, 'week')
    )
    const contractTime =
      contractTimeByWeek[formatToWeekISO(week)] || DEFAULT_CONTRACT_TIME

    const isCompleteWeek = getCompleteWeek(week, startDate, endDate)
    const workedHours =
      shiftsOfTheWeek.reduce(
        // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
        (acc, shift) => acc + getShiftRealDuration(shift, accountPaidBreaks),
        0
      ) / 60

    return {
      week: week.format('GGGG-[W]WW'),
      contract_time: contractTime,
      worked_hours: workedHours,
      is_complete_week: isCompleteWeek
    }
  })
}
